import React from 'react';
import "../../../styles/DefenceStyles/DefenceOverview.css";

// TOP LOGO IMAGE
import gemLogo from "../../.../../../assets/images/Defence/Overview/gem.png";

export default function CoreCapabilities() {
  return (
    <>
      {/* TOP SECTION */}
      <section className="defence-capabilities">
        <div className="cap-container">

          {/* TOP CENTER LOGO */}
          <div className="cap-logo">
            <img src={gemLogo} alt="GeM Government e Marketplace" />
          </div>

          {/* HEADER */}
          <h2>Defence Electronics Expertise</h2>
          <p className="cap-subtitle">
            Combat Solutions specializes in the design, development, and maintenance of mission-critical defence electronics. Our indigenous capabilities span weapon control systems, surveillance platforms, and combat management systems deployed across naval, air, and land forces.
          </p>

        </div>
      </section>

      {/* CORE CAPABILITIES SECTION */}
      <section className="CoreCapabilities">
        <div className="cap-container">

          {/* CORE TITLE */}
          <h3>Core Capabilities</h3>
          <p className="cap-subtext">
            Comprehensive defence electronics services from design to deployment
          </p>

          {/* CARDS GRID */}
          <div className="cap-grid">

            <div className="cap-card">
              <div className="cap-icon">
                <i className="bi bi-cpu"></i>
              </div>
              <h4>Design & Development</h4>
              <p>Indigenous design of mission-critical defence electronics</p>
            </div>

            <div className="cap-card">
              <div className="cap-icon">
                <i className="bi bi-tools"></i>
              </div>
              <h4>Repair & Maintenance</h4>
              <p>Expert repair services for weapon systems and platforms</p>
            </div>

            <div className="cap-card">
              <div className="cap-icon">
                <i className="bi bi-shield-lock"></i>
              </div>
              <h4>Rugged Electronics</h4>
              <p>MIL-grade electronics for harsh environments</p>
            </div>

            <div className="cap-card">
              <div className="cap-icon">
                <i className="bi bi-diagram-3"></i>
              </div>
              <h4>Interface & Fanout Solutions</h4>
              <p>RS-422/485/232 fanout and hybrid signal solutions</p>
            </div>

            <div className="cap-card">
              <div className="cap-icon">
                <i className="bi bi-clipboard-data"></i>
              </div>
              <h4>Defence Test Systems</h4>
              <p>Comprehensive test benches and validation equipment</p>
            </div>

            <div className="cap-card">
              <div className="cap-icon">
                <i className="bi bi-gear-wide-connected"></i>
              </div>
              <h4>System Integration & Support</h4>
              <p>End-to-end integration and field commissioning</p>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
